import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=5f554142"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/bamboo-agent-home/xml-data/build-dir/MEM-MEMUI-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f554142')) {
      api.createRecord('5f554142', component.options)
    } else {
      api.reload('5f554142', component.options)
    }
    module.hot.accept("./ContactUs.vue?vue&type=template&id=5f554142", function () {
      api.rerender('5f554142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/modal/ContactUs.vue"
export default component.exports